import { Component, ElementRef, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as moment from 'moment';

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD.MM.YYYY',
    },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'doc-form-date-time-picker',
    templateUrl: 'date-time-picker.component.html',
    styleUrls: ['date-time-picker.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_FORMATS
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DocDateTimePickerComponent),
            multi: true
        }
    ]
})

export class DocDateTimePickerComponent implements OnInit, ControlValueAccessor {
    @ViewChild('picker') pickerEl: ElementRef;

    @Input('parentForm') parentForm: UntypedFormGroup;
    @Input('controlName') controlName: string;

    @Input('readOnly') readOnly = false;
    @Input('label') label = '';
    @Input('disablePast') disablePast = false;
    @Input('startView') startView = 'month'; // 'month' | 'year' | 'multi-year'
    @Input('startAt') startAt = moment();

    @Input('hour') hour: string = '12';
    @Input('minute') minute: string = '00';
    @Input('timeInterval') timeInterval: any = 5;

    @Input('dateOnly') dateOnly = false;
    @Input('timeOnly') timeOnly = false;

    @Input() boldLabel = false;



    private today = moment();

    value: string | Date = '';
    changed = (value: any) => { };
    touched = () => { };
    disabled: boolean;

    // 
    hours = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
    minutesInTens = ['00', '10', '20', '30', '40', '50', '60'];
    minutesInFives = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60'];
    minutesInThirty = ['00', '30'];
    minutesInSixty = ['00'];


    private selectedTimestamp;

    constructor() { }

    writeValue(value: any): void {
        this.value = value ? value : '';
        if (value) {
            this.hour = moment(value).hour().toString();
            this.minute = moment(value).minute().toString();

            this.hour = parseInt(this.hour) < 10 ? '0' + this.hour : this.hour;
            this.minute = parseInt(this.minute) < 10 ? '0' + this.minute : this.minute;
        }
    }
    registerOnChange(fn: any): void {
        this.changed = fn;
    }
    registerOnTouched(fn: any): void {
        this.touched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    dateChange(type: string, event: MatDatepickerInputEvent<Date>) {
        this.value = event.value;
        this.createTimeStamp();
    }

    getMinimumDate() {
        if (this.disablePast) {
            return this.today;
        } else {
            return
        }
    }

    selectionChanged(e) {
        this.createTimeStamp();
    }

    createTimeStamp() {
        if (moment.isMoment(this.value)) {
            if (this.dateOnly) {
                this.selectedTimestamp = moment(this.value).format('YYYY-MM-DD');
            } else {
                this.selectedTimestamp = moment(this.value).hour(parseInt(this.hour)).minute(parseInt(this.minute)).toISOString();
            }
            this.changed(this.selectedTimestamp);
            this.touched();
        }
    }

    getMinutes() {
        switch (parseInt(this.timeInterval)) {
            case 5:
                return this.minutesInFives;
            case 10:
                return this.minutesInTens;
            case 30:
                return this.minutesInThirty;
            case 60:
                return this.minutesInSixty;
            default:
                return this.minutesInTens;
        }
    }

    ngOnInit() { }
}